import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = ({ data }) => {
  return (
    <section id="testimonials" className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-1/3 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl animate-pulse" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Client{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-yellow-500 bg-clip-text text-transparent">
              Testimonials
            </span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {data.length}+ real 5-star reviews from satisfied clients worldwide
          </p>
        </div>

        {/* Testimonials Grid - Scrollable */}
        <div className="max-h-[800px] overflow-y-auto pr-2 custom-scrollbar">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.map((testimonial, index) => {
              const delay = `delay-${Math.min((index % 9) * 100, 800)}`;
              return (
                <div key={testimonial.id} className={`animate-slide-in ${delay}`}>
                  <Card
                    className="group bg-slate-800/50 border-slate-700 hover:border-emerald-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-emerald-500/20 backdrop-blur-sm relative overflow-hidden hover:-translate-y-2"
                  >
                    <CardContent className="p-6 space-y-4">
                      {/* Quote Icon */}
                      <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500/20 to-yellow-500/20 flex items-center justify-center group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                        <Quote className="w-5 h-5 text-emerald-400" />
                      </div>

                      {/* Rating */}
                      <div className="flex gap-1">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500 group-hover:scale-125 transition-transform" style={{ transitionDelay: `${i * 50}ms` }} />
                        ))}
                      </div>

                      {/* Content */}
                      <p className="text-slate-300 leading-relaxed text-sm">"{testimonial.content}"</p>

                      {/* Author */}
                      <div className="pt-3 border-t border-slate-700 group-hover:border-emerald-500/30 transition-colors">
                        <p className="font-semibold text-white text-sm">{testimonial.name}</p>
                        <p className="text-xs text-slate-400">{testimonial.role}</p>
                        <p className="text-xs text-emerald-400">{testimonial.company}</p>
                      </div>

                      {/* Your Response */}
                      {testimonial.response && (
                        <div className="mt-3 p-3 bg-emerald-500/5 border border-emerald-500/20 rounded-lg">
                          <p className="text-xs text-slate-400 mb-1 font-medium">Your Response:</p>
                          <p className="text-xs text-slate-300">{testimonial.response}</p>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;